// extracted by mini-css-extract-plugin
module.exports = {"list":"post-preview-list_list__7d8R_","title":"post-preview-list_title__FCAi0"};